import React from 'react';
import { Box, Card } from '@mui/material';
import RouteConstants from '../../constants/routeConstants';
import { createTheme } from '@mui/system';
import { makeStyles } from '@mui/styles';

import { useThemeState } from '../../hookState/ThemeState';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import Title from '../../sharedcomponents/title/title';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    subPaperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(3),
        // height: '100%',
        width: '100%',
        display: 'flex',
    },
}));
const NotesDetails = (props) => {
    const classes = useStyles();
    const themeState = useThemeState();

    console.log(
        'props.history.location.state',
        props.history.location.state.notes
    );
    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ m: 2 }}>
                    <Title title={props.history.location.state.notes.title} />
                </Box>

                <Card
                    classes={{ root: classes.subPaperContent }}>
                    {props.history.location.state.notes != null && (
                        <DetailsComponent
                            data={props.history.location.state.notes.notesText}
                        />
                    )}
                </Card>
            </Box>
        </>
    );
};

export default {
    routeProps: {
        path: RouteConstants.EVENT_NOTES_DETAILS,
        component: NotesDetails,
    },
    name: 'NotesDetails',
};
